module.exports = __webpack_public_path__ + "static/ai-2-c801b2ec5e17f3a5d72f7ac7f7936c95.png";